// extracted by css-extract-rspack-plugin
module.exports =  {"documentManagementFilterViewer":"DocumentManagementFilterViewer__documentManagementFilterViewer___syXwV"};